import Scriba from 'react-scriba';

export const IDS_ECHEANCIERS = {
    NEW: -1,
    TYPE: -2,
};

export class DataEcheancier {

    static _chargementEcheanciers = (filtres, sortedColumn, isSortedDescending) => {
        const objet = { filtres, sortedColumn, isSortedDescending };
        const url = "api/Liste/ListeDesEcheanciers";
        const paramPost = Scriba.fetch().createParameterPost(objet);
        return fetch(url, paramPost).then(response => response.json());
    };

    static _chargementEcheancier = (idOperation, idEcheancier, inclureEcheancierAuxEchanciersLies) => {
        const objet = { idOperation, idEcheancier, inclureEcheancierAuxEchanciersLies };

        let url = "api/Fiche/FicheEcheancier";
        if (idEcheancier === IDS_ECHEANCIERS.TYPE) url = "api/Fiche/FicheEcheancierType";

        const paramPost = Scriba.fetch().createParameterPost(objet);
        return fetch(url, paramPost).then(response => response.json());
    };

    static _onEnregistrementEcheancier = (echeancier, stades, idOperation) => {
        const objet = { echeancier, stades, idOperation };
        const url = "api/MAJDonnees/EnregistrementEcheancier";
        const paramPost = Scriba.fetch().createParameterPost(objet);
        return fetch(url, paramPost).then(response => response.json());
    };

    static _onSuppressionEcheancier = (idOperation, idEcheancier) => {
        const objet = { idOperation, idEcheancier };
        const url = "api/MAJDonnees/SuppressionEcheancier";
        const paramPost = Scriba.fetch().createParameterPost(objet);
        return fetch(url, paramPost).then(response => response.json());
    };

}
